var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
const ContrastCheckedIcon = (_a) => {
    var { boxColor, checkColor } = _a, svgIconProps = __rest(_a, ["boxColor", "checkColor"]);
    return (React.createElement(SvgIcon, Object.assign({}, svgIconProps, { viewBox: "0 0 16 16" }),
        React.createElement("rect", { className: "contrast-checked-icon-box", x: "1.83325", y: "1.83301", width: "12.3333", height: "12.3333", rx: "2.16667", fill: boxColor, stroke: boxColor }),
        React.createElement("path", { className: "contrast-checked-icon-tick", d: "M9.9797 5.64645C10.175 5.45118 10.4915 5.45118 10.6867 5.64645C10.882 5.84171 10.882 6.15822 10.6867 6.35348L7.5422 9.49801C7.2428 9.79741 6.75697 9.79741 6.45756 9.49801L4.9797 8.02014C4.78444 7.82488 4.78444 7.50838 4.9797 7.31311C5.17496 7.11785 5.49147 7.11785 5.68673 7.31311L6.99988 8.62626L9.9797 5.64645Z", fill: checkColor })));
};
export default ContrastCheckedIcon;
